import { render, staticRenderFns } from "./phoneExtItemSortable.vue?vue&type=template&id=9a505fa2&scoped=true&"
import script from "./phoneExtItemSortable.vue?vue&type=script&lang=js&"
export * from "./phoneExtItemSortable.vue?vue&type=script&lang=js&"
import style0 from "./phoneExtItemSortable.vue?vue&type=style&index=0&id=9a505fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a505fa2",
  null
  
)

export default component.exports